import { View, ViewStyle } from 'react-native'
import { Avatar } from 'react-native-paper'
import { StyleSheet } from 'react-native-unistyles'

interface Props {
  user?: {
    emailHash?: string | null
    firstName: string
    lastName: string
  }
  size: number
  style?: ViewStyle
  testID?: string
}

const BORDER_WIDTH = 2

const UserAvatar = (props: Props) => {
  const gravatarUrl = `https://www.gravatar.com/avatar/${props.user?.emailHash}?d=retro&size=${props.size * 2}`

  return (
    <View style={props.style} testID={props.testID}>
      <View
        style={[
          styles.borderRing,
          {
            width: props.size + BORDER_WIDTH * 2,
            height: props.size + BORDER_WIDTH * 2,
            borderRadius: (props.size + BORDER_WIDTH * 2) / 2,
          },
        ]}
      >
        <Avatar.Image
          size={props.size}
          source={{
            uri: gravatarUrl,
          }}
          style={styles.avatar}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    avatar: {
      backgroundColor: 'transparent',
    },
    borderRing: {
      alignItems: 'center',
      backgroundColor: theme.colors.surface,
      borderColor: theme.colors.cardBorder,
      borderRadius: 100,
      borderWidth: BORDER_WIDTH,
      justifyContent: 'center',
      overflow: 'hidden',
    },
  }
})

export default UserAvatar
